// extracted by mini-css-extract-plugin
export default {"container":"films_container__2kczS","title":"films_title__10EB8"};